/**
 * This file is used to set up a listener middleware for Redux. After `configureStore`
 * is called in store.tsx, `setupMiddlewareListeners` is called to start the listeners.
 *
 * Docs - https://redux-toolkit.js.org/api/createListenerMiddleware#typescript-usage
 */

import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import {
  initIntentConversation,
  sendFreeFormQuery,
} from 'actions/workflows-v2/workflowsV2';
import { reloadTranslatedWidgetConfig } from 'actions/workflows/workflows';
import type { RootState } from 'reducers/root';
import type { AppDispatch } from 'store';

/**
 * https://redux-toolkit.js.org/api/createListenerMiddleware
 */
export const listenerMiddleware = createListenerMiddleware();

const startAppListening = listenerMiddleware.startListening.withTypes<
  RootState,
  AppDispatch,
  unknown
>();

export function setupMiddlewareListeners() {
  /**
   * Reload the translated widget config listener
   */
  startAppListening({
    effect: (action, listenerApi) => {
      listenerApi.dispatch(reloadTranslatedWidgetConfig());
    },
    matcher: isAnyOf(
      initIntentConversation.fulfilled,
      sendFreeFormQuery.fulfilled,
    ),
  });
}
